import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function onboardingCn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/** Scoped overrides for SetupWizard when parent passes isDarkMode. */
export const SETUP_WIZARD_DARK_STYLES = `
  .rv-setup-wizard--dark {
    color: #e2e8f0;
  }
  .rv-setup-wizard--dark .bg-white,
  .rv-setup-wizard--dark .bg-white\\/35,
  .rv-setup-wizard--dark .bg-white\\/45,
  .rv-setup-wizard--dark .bg-white\\/50,
  .rv-setup-wizard--dark .bg-white\\/55,
  .rv-setup-wizard--dark .bg-white\\/60,
  .rv-setup-wizard--dark .bg-white\\/70,
  .rv-setup-wizard--dark .bg-white\\/90 {
    background-color: rgba(15, 23, 42, 0.94) !important;
  }
  .rv-setup-wizard--dark .bg-slate-50,
  .rv-setup-wizard--dark .bg-slate-50\\/60,
  .rv-setup-wizard--dark .bg-slate-50\\/80,
  .rv-setup-wizard--dark .bg-slate-50\\/90,
  .rv-setup-wizard--dark .bg-slate-100,
  .rv-setup-wizard--dark .bg-slate-100\\/80 {
    background-color: rgba(30, 41, 59, 0.92) !important;
  }
  /* Light marketing / bolt-on gradient panes → solid dark surfaces */
  .rv-setup-wizard--dark .bg-gradient-to-br,
  .rv-setup-wizard--dark .bg-gradient-to-b,
  .rv-setup-wizard--dark .from-slate-50,
  .rv-setup-wizard--dark .from-slate-100\\/80,
  .rv-setup-wizard--dark .via-sky-50\\/40,
  .rv-setup-wizard--dark .via-sky-50\\/50,
  .rv-setup-wizard--dark .to-indigo-50\\/50,
  .rv-setup-wizard--dark .to-violet-50\\/40,
  .rv-setup-wizard--dark .from-white\\/50,
  .rv-setup-wizard--dark .from-white\\/55,
  .rv-setup-wizard--dark .via-white\\/10,
  .rv-setup-wizard--dark .to-sky-100\\/20,
  .rv-setup-wizard--dark .to-transparent {
    background-image: none !important;
  }
  .rv-setup-wizard--dark .from-slate-50,
  .rv-setup-wizard--dark .from-slate-100\\/80,
  .rv-setup-wizard--dark section.bg-gradient-to-br,
  .rv-setup-wizard--dark div.bg-gradient-to-br {
    background-color: rgba(15, 23, 42, 0.92) !important;
  }
  .rv-setup-wizard--dark .bg-sky-200\\/35,
  .rv-setup-wizard--dark .bg-sky-200\\/30,
  .rv-setup-wizard--dark .bg-indigo-200\\/30,
  .rv-setup-wizard--dark .bg-violet-200\\/25 {
    background-color: transparent !important;
    opacity: 0 !important;
  }
  .rv-setup-wizard--dark .bg-indigo-50,
  .rv-setup-wizard--dark .bg-indigo-50\\/50,
  .rv-setup-wizard--dark .bg-indigo-50\\/60,
  .rv-setup-wizard--dark .bg-indigo-50\\/80,
  .rv-setup-wizard--dark .bg-indigo-100,
  .rv-setup-wizard--dark .bg-sky-50,
  .rv-setup-wizard--dark .bg-violet-50,
  .rv-setup-wizard--dark .bg-emerald-50\\/80 {
    background-color: rgba(49, 46, 129, 0.35) !important;
  }
  .rv-setup-wizard--dark .text-slate-900,
  .rv-setup-wizard--dark .text-slate-800 {
    color: #f8fafc !important;
  }
  .rv-setup-wizard--dark .text-slate-700,
  .rv-setup-wizard--dark .text-slate-600 {
    color: #cbd5e1 !important;
  }
  .rv-setup-wizard--dark .text-slate-500 {
    color: #94a3b8 !important;
  }
  .rv-setup-wizard--dark .text-slate-400 {
    color: #94a3b8 !important;
  }
  .rv-setup-wizard--dark .text-indigo-700,
  .rv-setup-wizard--dark .text-indigo-800,
  .rv-setup-wizard--dark .text-violet-700,
  .rv-setup-wizard--dark .text-emerald-700,
  .rv-setup-wizard--dark .text-cyan-800,
  .rv-setup-wizard--dark .text-amber-900,
  .rv-setup-wizard--dark .text-emerald-900 {
    color: #c7d2fe !important;
  }
  .rv-setup-wizard--dark .border-slate-100,
  .rv-setup-wizard--dark .border-slate-200,
  .rv-setup-wizard--dark .border-slate-200\\/80,
  .rv-setup-wizard--dark .border-slate-200\\/90,
  .rv-setup-wizard--dark .border-slate-300,
  .rv-setup-wizard--dark .border-white\\/40,
  .rv-setup-wizard--dark .border-white\\/50,
  .rv-setup-wizard--dark .border-white\\/65,
  .rv-setup-wizard--dark .border-sky-100\\/35,
  .rv-setup-wizard--dark .ring-sky-100\\/25,
  .rv-setup-wizard--dark .ring-sky-100\\/35 {
    border-color: #475569 !important;
    --tw-ring-color: rgba(71, 85, 105, 0.65) !important;
  }
  .rv-setup-wizard--dark input:not([type="checkbox"]):not([type="radio"]),
  .rv-setup-wizard--dark textarea,
  .rv-setup-wizard--dark select {
    background-color: #1e293b !important;
    color: #f8fafc !important;
    border-color: #475569 !important;
  }
  .rv-setup-wizard--dark input::placeholder,
  .rv-setup-wizard--dark textarea::placeholder {
    color: #64748b !important;
  }
  .rv-setup-wizard--dark .bg-amber-50,
  .rv-setup-wizard--dark .bg-amber-50\\/50,
  .rv-setup-wizard--dark .bg-amber-50\\/80 {
    background-color: rgba(120, 53, 15, 0.45) !important;
  }
  .rv-setup-wizard--dark .border-amber-200,
  .rv-setup-wizard--dark .border-amber-300 {
    border-color: rgba(245, 158, 11, 0.45) !important;
  }
  .rv-setup-wizard--dark .text-amber-800,
  .rv-setup-wizard--dark .text-amber-900,
  .rv-setup-wizard--dark .text-amber-950,
  .rv-setup-wizard--dark .text-amber-700 {
    color: #fde68a !important;
  }
  .rv-setup-wizard--dark .bg-red-50 {
    background-color: rgba(127, 29, 29, 0.35) !important;
  }
  .rv-setup-wizard--dark .border-red-200 {
    border-color: rgba(248, 113, 113, 0.4) !important;
  }
  .rv-setup-wizard--dark .text-red-700,
  .rv-setup-wizard--dark .text-red-600 {
    color: #fecaca !important;
  }
  .rv-setup-wizard--dark .bg-emerald-50 {
    background-color: rgba(6, 78, 59, 0.35) !important;
  }
  .rv-setup-wizard--dark .border-emerald-200,
  .rv-setup-wizard--dark .border-emerald-200\\/80 {
    border-color: rgba(52, 211, 153, 0.4) !important;
  }
  .rv-setup-wizard--dark .text-emerald-800,
  .rv-setup-wizard--dark .text-emerald-900 {
    color: #a7f3d0 !important;
  }
  .rv-setup-wizard--dark .hover\\:bg-slate-100:hover {
    background-color: #334155 !important;
  }
  .rv-setup-wizard--dark .hover\\:text-slate-900:hover {
    color: #f8fafc !important;
  }
  .rv-setup-wizard--dark .hover\\:bg-amber-100\\/80:hover {
    background-color: rgba(120, 53, 15, 0.5) !important;
  }
  .rv-setup-wizard--dark .hover\\:bg-white:hover,
  .rv-setup-wizard--dark .hover\\:bg-slate-50:hover {
    background-color: #334155 !important;
  }
  .rv-setup-wizard--dark .shadow-indigo-200\\/50,
  .rv-setup-wizard--dark .shadow-indigo-200\\/40,
  .rv-setup-wizard--dark .shadow-violet-200\\/40,
  .rv-setup-wizard--dark .shadow-emerald-200\\/40,
  .rv-setup-wizard--dark .shadow-cyan-200\\/40,
  .rv-setup-wizard--dark .shadow-amber-200\\/40 {
    --tw-shadow-color: rgba(0, 0, 0, 0.35) !important;
  }
`;

/** Scoped overrides for system-admin New Company registration in dark mode. */
export const NEW_COMPANY_DARK_STYLES = `
  .rv-new-company--dark {
    color: #e2e8f0;
  }
  .rv-new-company--dark .bg-white {
    background-color: rgba(15, 23, 42, 0.96) !important;
  }
  .rv-new-company--dark .bg-slate-50,
  .rv-new-company--dark .bg-slate-50\\/80,
  .rv-new-company--dark .bg-slate-100 {
    background-color: rgba(30, 41, 59, 0.92) !important;
  }
  .rv-new-company--dark .hover\\:bg-slate-50:hover {
    background-color: #334155 !important;
  }
  .rv-new-company--dark .text-slate-900,
  .rv-new-company--dark .text-slate-800 {
    color: #f8fafc !important;
  }
  .rv-new-company--dark .text-slate-700,
  .rv-new-company--dark .text-slate-600 {
    color: #cbd5e1 !important;
  }
  .rv-new-company--dark .text-slate-500,
  .rv-new-company--dark .text-slate-400 {
    color: #94a3b8 !important;
  }
  .rv-new-company--dark .border-slate-100,
  .rv-new-company--dark .border-slate-200,
  .rv-new-company--dark .border-slate-300 {
    border-color: #475569 !important;
  }
  .rv-new-company--dark input:not([type="checkbox"]):not([type="radio"]),
  .rv-new-company--dark textarea,
  .rv-new-company--dark select {
    background-color: #1e293b !important;
    color: #f8fafc !important;
    border-color: #475569 !important;
  }
  .rv-new-company--dark input::placeholder,
  .rv-new-company--dark textarea::placeholder {
    color: #64748b !important;
  }
  .rv-new-company--dark .bg-red-50 {
    background-color: rgba(127, 29, 29, 0.35) !important;
  }
  .rv-new-company--dark .border-red-100,
  .rv-new-company--dark .border-red-200 {
    border-color: rgba(248, 113, 113, 0.4) !important;
  }
  .rv-new-company--dark .text-red-600 {
    color: #fecaca !important;
  }
  .rv-new-company--dark .bg-emerald-50 {
    background-color: rgba(6, 78, 59, 0.35) !important;
  }
  .rv-new-company--dark .border-emerald-100,
  .rv-new-company--dark .border-emerald-200 {
    border-color: rgba(52, 211, 153, 0.4) !important;
  }
  .rv-new-company--dark .text-emerald-700 {
    color: #a7f3d0 !important;
  }
  .rv-new-company--dark .bg-amber-50 {
    background-color: rgba(120, 53, 15, 0.35) !important;
  }
  .rv-new-company--dark .border-amber-200 {
    border-color: rgba(245, 158, 11, 0.45) !important;
  }
  .rv-new-company--dark .text-amber-800 {
    color: #fde68a !important;
  }
  .rv-new-company--dark .bg-indigo-50\\/70 {
    background-color: rgba(49, 46, 129, 0.35) !important;
  }
  .rv-new-company--dark .border-indigo-100,
  .rv-new-company--dark .border-indigo-200 {
    border-color: rgba(129, 140, 248, 0.4) !important;
  }
`;
